import ApiService from './api.service'

const CampaignService = {
  async list() {
    try {
      return await ApiService.get('campaigns', {})
    } catch (error) {
      return error.response.data
    }
  },
  async create(data) {
    try {
      return await ApiService.post('campaign', data)
    } catch (error) {
      return error.response.data
    }
  },
  async update(data) {
    try {
      return await ApiService.put('campaign', data)
    } catch (error) {
      return error.response.data
    }
  },
  async remove(id) {
    try {
      return await ApiService.delete(`campaign/${id}`)
    } catch (error) {
      return error.response.data
    }
  },
  async show(id) {
    try {
      return await ApiService.get(`campaign/${id}`)
    } catch (error) {
      return error.response
    }
  },
  async assignUser(data) {
    try {
      return await ApiService.post('campaign/user', data)
    } catch (error) {
      return error.response.data
    }
  },
  async assignUsers(data) {
    try {
      return await ApiService.post(`campaign/users/${data.id}`, data)
    } catch (error) {
      return error.response.data
    }
  },
  async transferUsers(data) {
    try {
      return await ApiService.post(`campaign/transfer/${data.id}`, data)
    } catch (error) {
      return error.response.data
    }
  }
}

export { CampaignService }
